// prefer default export if available
const preferDefault = m => m && m.default || m

exports.components = {
  "component---src-pages-imprint-js": () => import("C:\\Users\\Andreas\\Desktop\\dev\\gatsbygalore\\src\\pages\\imprint.js" /* webpackChunkName: "component---src-pages-imprint-js" */),
  "component---src-pages-index-js": () => import("C:\\Users\\Andreas\\Desktop\\dev\\gatsbygalore\\src\\pages\\index.js" /* webpackChunkName: "component---src-pages-index-js" */),
  "component---src-pages-privacy-policy-js": () => import("C:\\Users\\Andreas\\Desktop\\dev\\gatsbygalore\\src\\pages\\privacy-policy.js" /* webpackChunkName: "component---src-pages-privacy-policy-js" */)
}

